import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="initialize-before-submit"
export default class extends Controller {
  static targets = ["orders", "orderCodes"];
  connect() {
    console.log("initializeBeforeSubmit controller connected");
  }

  call(event) {
    event.preventDefault();
    const form = this.element;

    form.submit();

    setTimeout(() => {
      this.ordersTarget.innerHTML = "";
      this.orderCodesTarget.value = "";
    }, 0);
  }
}
